import { render, staticRenderFns } from "./OnlinePay.vue?vue&type=template&id=0dc81cc6&scoped=true&"
import script from "./OnlinePay.vue?vue&type=script&lang=js&"
export * from "./OnlinePay.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePay.vue?vue&type=style&index=0&id=0dc81cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc81cc6",
  null
  
)

export default component.exports